"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var CustomPagination_1 = __importDefault(require("./CustomPagination"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var material_1 = require("@mui/material");
var inertia_1 = require("@inertiajs/inertia");
var AppIntegrationTemplateMenu = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(), integrationTemplateList = _a[0], setIntegrationTemplateList = _a[1];
    var _b = (0, react_1.useState)(1), integrationTemplateListPage = _b[0], setIntegrationTemplateListPage = _b[1];
    var _c = (0, react_1.useState)(""), integrationTemplateListSearch = _c[0], setIntegrationTemplateListSearch = _c[1];
    var searchDebouncer = (0, react_1.useMemo)(function () { return new q_play_core_1.Debouncer(function (search) { setIntegrationTemplateListSearch(search); }, 350); }, [setIntegrationTemplateListSearch]);
    var loadIntegrationTemplates = function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        pagination: { page: integrationTemplateListPage, perPage: 4 },
                        sort: { field: "id", order: "ASC" },
                        filter: {}
                    };
                    if (integrationTemplateListSearch !== "") {
                        params.filter.search = integrationTemplateListSearch;
                    }
                    return [4 /*yield*/, (0, AjaxProvider_1.default)("/api").getList("app-integration-templates", params)];
                case 1:
                    response = _a.sent();
                    setIntegrationTemplateList(response);
                    return [2 /*return*/];
            }
        });
    }); };
    var setAppIntegrationTemplateId = function (eventOrClassId) {
        if (typeof eventOrClassId === "string") {
            props.setAppIntegrationTemplateId(eventOrClassId);
        }
        else if (eventOrClassId.target instanceof HTMLAnchorElement) {
            var classId = eventOrClassId.target.dataset.classId;
            if (classId) {
                props.setAppIntegrationTemplateId(classId);
            }
            else {
                props.setAppIntegrationTemplateId(undefined);
            }
        }
    };
    var onSearchChange = function (event) {
        searchDebouncer.debounce(event.target.value);
    };
    var setPageHandler = function (page) {
        setIntegrationTemplateListPage(page);
    };
    (0, react_1.useEffect)(function () {
        loadIntegrationTemplates();
    }, [integrationTemplateListPage, integrationTemplateListSearch]);
    (0, react_1.useEffect)(function () {
        props.setTitle(t("Select integration"));
    }, []);
    return (react_1.default.createElement("div", { "data-cy": "appIntegrationTemplateMenu", className: "".concat(AppIntegrations_module_css_1.default["integration-class-menu"], " ").concat(AppIntegrations_module_css_1.default["integration-template-menu"]) },
        react_1.default.createElement("div", { className: "".concat(AppIntegrations_module_css_1.default["search-container"], " ns-font-family") },
            react_1.default.createElement(q_play_components_1.Input, { type: "text", placeholder: t("Search"), onChange: onSearchChange, className: AppIntegrations_module_css_1.default["search-input"], "data-cy": "appIntegrationTemplateMenuSearch" }),
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { style: { marginLeft: "-34px" }, icon: free_solid_svg_icons_1.faMagnifyingGlass, color: "var(--primary-color)" })),
        react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["item-list"] }, (integrationTemplateList === null || integrationTemplateList === void 0 ? void 0 : integrationTemplateList.data.length) > 0 ? (integrationTemplateList === null || integrationTemplateList === void 0 ? void 0 : integrationTemplateList.data.map(function (data) {
            return (react_1.default.createElement("div", { key: data.id, className: AppIntegrations_module_css_1.default["item"] },
                react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["name-column"] },
                    react_1.default.createElement("img", { src: data.icon, style: { width: "100px", height: "100px" } }),
                    react_1.default.createElement("br", null),
                    data.name),
                react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["description-column"] },
                    data.approved_at
                        ? react_1.default.createElement(react_1.default.Fragment, null)
                        : react_1.default.createElement("div", { style: { fontStyle: "italic" } },
                            react_1.default.createElement(material_1.Badge, { color: "success" },
                                "(",
                                t("Unapproved template"),
                                ")")),
                    react_1.default.createElement("div", { style: { height: "70px" } }, data.description),
                    react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["button-container"] },
                        data.type === "webapi"
                            ? react_1.default.createElement(q_play_components_1.Button, { text: t("Configure"), variant: "primary", size: "small", onClick: function () { return inertia_1.Inertia.visit("/integration/create/".concat(data.id)); }, "data-cy": "configureIntegration" })
                            : react_1.default.createElement(q_play_components_1.Button, { text: t("Configure"), variant: "primary", size: "small", onClick: function () { return setAppIntegrationTemplateId(data.id); }, "data-cy": "configureIntegration" }),
                        react_1.default.createElement(q_play_components_1.Button, { text: t("Read more") + "...", variant: "secondary", size: "small", onClick: function () { return window.open(data.description_link, "blank"); } })))));
        })) : (react_1.default.createElement("div", { className: "text-center mt-4" }, t("No integration template found")))),
        react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["footer"] },
            react_1.default.createElement(CustomPagination_1.default, { pagination: integrationTemplateList === null || integrationTemplateList === void 0 ? void 0 : integrationTemplateList.meta, setPageHandler: setPageHandler }))));
};
exports.default = AppIntegrationTemplateMenu;
